import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";

const CATS = ["Plumbing","Electrical","Roofing","Landscaping","Renovation","HVAC","Painting","Flooring","Cleaners","Photography","Private Home Chef","Child Care"];

export default function PostProject() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: "", description: "", category: "Renovation", location: "Columbia Valley", budget: "", timeline: "" });

  useEffect(() => {
    if (!loading && !user) navigate("/login");
    if (!loading && user && user.role !== "homeowner") {
      toast.error("Only homeowners can post projects");
      navigate("/");
    }
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!user?.subscription_active) {
      toast.error("Subscribe to post projects");
      navigate("/pricing");
      return;
    }
    try {
      const payload = { ...form, budget: form.budget ? parseFloat(form.budget) : null };
      const { data } = await api.post("/projects", payload);
      toast.success("Project posted!");
      navigate(`/projects/${data.project_id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to post project");
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-5 py-12">
      <div className="overline text-[#B85C47] mb-3">Post a Project</div>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-8" style={{ fontFamily: "Outfit" }}>Tell us about your project</h1>

      <form onSubmit={submit} className="bg-white border border-[#E2DCD0] rounded-xl p-6 space-y-4">
        <div>
          <Label>Project title</Label>
          <Input data-testid="project-title-input" required value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="Kitchen renovation in Invermere" />
        </div>
        <div>
          <Label>Category</Label>
          <Select value={form.category} onValueChange={v => setForm({...form, category: v})}>
            <SelectTrigger data-testid="project-category-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {CATS.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Description</Label>
          <Textarea data-testid="project-description-input" required rows={5} value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="Describe the scope, materials, anything special…" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Location</Label>
            <Input data-testid="project-location-input" value={form.location} onChange={e => setForm({...form, location: e.target.value})} />
          </div>
          <div>
            <Label>Budget ($)</Label>
            <Input data-testid="project-budget-input" type="number" value={form.budget} onChange={e => setForm({...form, budget: e.target.value})} placeholder="optional" />
          </div>
        </div>
        <div>
          <Label>Timeline</Label>
          <Input data-testid="project-timeline-input" value={form.timeline} onChange={e => setForm({...form, timeline: e.target.value})} placeholder="e.g. ASAP, within 3 months" />
        </div>
        <Button data-testid="project-submit-btn" type="submit" className="w-full bg-[#314A3E] hover:bg-[#243a30] text-white h-11">Post project</Button>
      </form>
    </div>
  );
}
